<template>
  <div v-show.async="show">
    <div class="panel mt-20">
      <el-form
        label-position="left"
        class="flex-row-between"
        label-width="70px"
      >
        <el-form-item label="拜访时间">
          <el-date-picker
            style="width: 340px"
            v-model="date"
            size="mini"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="拜访类型">
          <el-select
            style="width: 180px"
            size="mini"
            v-model="type"
            placeholder="请选择"
          >
            <el-option
              v-for="item in followupTypes"
              :key="item.label"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-button size="mini" type="primary" @click="startFilter()"
        >搜索</el-button
      >
      <el-button size="mini" @click="clearFilter">清空</el-button>
    </div>
    <div class="panel mt-20">
      <el-button
        type="primary"
        icon="el-icon-notebook-2"
        size="small"
        @click="startCreateFollowup"
        >新拜访</el-button
      >
      <el-table
        v-if="!isMobile()"
        :data="followups"
        stripe
        style="width: 100%"
        key="followups"
      >
        <el-table-column prop="origin" width="100" label="拜访类型">
          <template slot-scope="scope">
            <span>{{ followupTypeMap[scope.row.type] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="user"
          label="沟通人员"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.customer_contact.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="date"
          label="拜访日期"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ formatTime(scope.row.created_at) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="content"
          label="沟通内容"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="amount"
          label="费用"
          width="100"
          align="right"
        ></el-table-column>
      </el-table>
      <ul v-else class="list-style">
        <li v-for="(item, index) in followups">
          <div class="flex-row-between">
            <span>{{ followupTypeMap[item.type] }}</span>
            <span class="font-12" v-if="item.amount > 0"
              >￥{{ item.amount }}</span
            >
          </div>
          <div class="font-12">{{ item.content }}</div>
          <div class="text-info-12 flex-row-between">
            <span>拜访：{{ item.customer_contact.name }}</span>
            <span>{{ formatTime(item.created_at) }}</span>
          </div>
        </li>
      </ul>
      <el-pagination
        class="mt-20"
        :page-size="pageSize"
        :current-page.sync="currentPage"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { customerFollowupList } from '../../service/getData'
import { formatTime, isMobile } from '@/util/index'
import { CustomerFollowupTypes } from '@/config/global'
import { clone } from '@/util'

export default {
  props: {
    customerID: {
      type: Number,
      default: 0,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formatTime,
      isMobile,
      followupTypes: clone(CustomerFollowupTypes),
      followups: [],
      total: 0,
      type: 0,
      date: null,
      pageSize: 20,
      currentPage: 1,
    }
  },
  computed: {
    followupTypeMap() {
      let map = {}
      this.followupTypes.map((item) => {
        map[item.value] = item.label
      })
      return map
    },
  },
  watch: {
    show() {
      if (this.show && this.followups.length == 0) {
        this.requestCustomerFollowups()
      }
    },
    currentPage() {
      this.requestCustomerFollowups()
    },
  },
  created() {
    this.followupTypes.unshift({
      label: '所有类型',
      value: 0,
    })

    if (this.show) {
      this.requestCustomerFollowups()
    }
  },
  methods: {
    refresh() {
      this.clearFilter()
    },
    async requestCustomerFollowups() {
      let data = {
        page: this.currentPage - 1,
        size: this.pageSize,
        type: this.type,
        customer_id: this.customerID,
      }
      if (this.date) {
        data.start_date = this.date[0]
        data.end_date = this.date[1]
      }

      let res = await customerFollowupList(data)
      if (res.code == 0) {
        this.followups = res.data.list
        this.total = res.data.total
      }
    },
    startFilter() {
      this.currentPage = 1
      this.requestCustomerFollowups()
    },
    clearFilter() {
      this.date = null
      this.type = 0
      this.currentPage = 1
      this.requestCustomerFollowups()
    },
    startCreateFollowup() {
      this.$emit('newfollow')
    },
  },
}
</script>

<style scoped>
</style>